import { get } from 'communication/httpClient';
import { ICategory } from 'types';
import {
  LOAD_ROOT_CATEGORIES,
  ROOT_CATEGORIES_LOADED,
  SYNC_FAILED,
  RESET_CATEGORIES,
  LOAD_CATEGORY,
  CATEGORY_LOADED,
  LOAD_SUBCATEGORIES,
  LOAD_ANCESTORS,
  ANCESTORS_LOADED,
  LOAD_ROOT_SUB_CATEGORIES,
  SET_ROOT_SUB_CATEGORIES,
  BUILD_ROOT_SUB_CATEGORIES_HIERARCHY,
  LOADED_ROOT_SUB_CATEGORIES,
  ROOT_SUB_CATEGORIES_SYNC_FAILED,
  RESET_SUB_CATEGORIES_ERROR
} from './actionTypes';
import { ICategoryAncestors, IRootSubCategoryName } from './types';

export const initialActionsState = {
  loadRootCategories: () => {},
  loadCategory: (root: string) => {},
  loadSubcategories: (parentId: string) => {},
  loadAncestors: (nodeIds: string | string[]) => {},
  loadMultipleAncestors: (nodeIds: string[]) => {},
  resetCategories: () => {},
  loadRootSubCategories: (root: string) => {},
  resetSubCategoriesError: () => {}
};

export const getActions = (dispatch: {
  (value: { type: any; payload?: any }): void;
  (arg0: { type: string; payload?: any }): void;
}) => ({
  loadRootCategories: async () => {
    dispatch({
      type: LOAD_ROOT_CATEGORIES,
    });
    const { data, error } = await get('/api/catalog/categories');

    if (data) {
      dispatch({
        type: ROOT_CATEGORIES_LOADED,
        payload: data,
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
  },
  loadCategory: async (root: string, callback?: () => void) => {
    dispatch({
      type: LOAD_CATEGORY,
    });

    const { data, error } = await get(`/api/catalog/categories?root=${root}`);

    if (data) {
      dispatch({
        type: CATEGORY_LOADED,
        payload: data,
      });
      if (callback) {
        callback();
      }
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
  },
  loadSubcategories: async (parentId: string, root: IRootSubCategoryName) => {
    dispatch({
      type: LOAD_SUBCATEGORIES,
      payload: root,
    });
    const { data, error } = await get(`/api/catalog/categories?parentId=${parentId}`);

    if (data) {
      dispatch({
        type: BUILD_ROOT_SUB_CATEGORIES_HIERARCHY,
        payload: {
          parentId,
          subcategories: data,
          root,
        },
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
  },

  loadAncestors: async (nodeIds: string | string[]) => {
    dispatch({
      type: LOAD_ANCESTORS,
    });

    if (typeof nodeIds === 'string') {
      const { data, error } = await get(`/api/catalog/categories/${nodeIds}/ancestors`);
      if (data) {
        dispatch({
          type: ANCESTORS_LOADED,
          payload: {
            [nodeIds]: data,
          },
        });
      } else {
        dispatch({
          type: SYNC_FAILED,
          payload: error,
        });
      }
    }

    if (Array.isArray(nodeIds)) {
      const promises = nodeIds.map((id) => get(`/api/catalog/categories/${id}/ancestors`));
      const data: ICategoryAncestors = {};

      const ancestorsArray: ICategory[][] = [];
      const results = await Promise.all(promises);
      for(const result of results){
        if(result?.error && result.error.status >=500){
          dispatch({
            type: SYNC_FAILED,
            payload: result?.error,
          });
          return;
        }
      }
      results.forEach((res) => {
        ancestorsArray.push(res.data);
      });
      nodeIds.forEach((id, index) => {
        data[id] = ancestorsArray[index];
      });


      if (Object.keys(data).length) {
        dispatch({
          type: ANCESTORS_LOADED,
          payload: data,
        });
      }
    }
  },

  loadRootSubCategories: async (root: string) => {
    dispatch({
      type: LOAD_ROOT_SUB_CATEGORIES,
      payload: root,
    });

    const { data, error } = await get(`/api/catalog/categories?root=${root}`);
    if (data) {
      dispatch({
        type: SET_ROOT_SUB_CATEGORIES,
        payload: { data, root },
      });

      const [{ nodeId: { nodeId = '' } = {} }] = data;

      const { data: subcategories, error: subCategoriesError } = await get(
        `/api/catalog/categories?parentId=${nodeId}`
      );

      if (subcategories) {
        dispatch({
          type: BUILD_ROOT_SUB_CATEGORIES_HIERARCHY,
          payload: {
            parentId: nodeId,
            subcategories,
            root,
          },
        });
        dispatch({
          type: LOADED_ROOT_SUB_CATEGORIES,
          payload: root,
        });
      } else {
        dispatch({
          type: ROOT_SUB_CATEGORIES_SYNC_FAILED,
          payload: { error: subCategoriesError, root },
        });
      }
    } else {
      dispatch({
        type: ROOT_SUB_CATEGORIES_SYNC_FAILED,
        payload: { error, root },
      });
    }
  },
  resetSubCategoriesError: ()=> {
    dispatch({
      type: RESET_SUB_CATEGORIES_ERROR,
    })
  },
  resetCategories: () =>
    dispatch({
      type: RESET_CATEGORIES,
    }),
});
